module.exports = __webpack_public_path__ + "static/media/bg-icon.cd55e861.png";